import { createMuiTheme } from "@material-ui/core";

export const sizes = {
  pageMaxWidth: 1440,
};

const spacing = 24;

const theme = createMuiTheme({
  overrides: {
    MuiCheckbox: {
      colorSecondary: {
        "&.Mui-checked": {
          color: "#AEC80B",
        },
      },
    },

    MuiTabs: {
      root: {
        background: "#E5E5E5",
        borderRadius: "8px",
      },
      indicator: {
        display: "none",
      },
      flexContainer: {
        flexDirection: "row",
        alignItems: "center",
      },
    },
    MuiAccordion: {
      root: {
        boxShadow: "none",
        border: "none",
        background: "#F3F3F3",
        borderRadius: "8px!important",

        "&::before": {
          display: "none",
        },
      },
    },
    MuiBackdrop: {
      root: {
        backdropFilter: "blur(24px)",
        backgroundColor: "rgba(255,255,255,0.4)",
      },
    },
    MuiAccordionSummary: {
      root: {
        padding: "0 24px",
        "&.Mui-expanded": {
          minHeight: "56px",
          borderBottom: "1px solid #E5E5E5",
          marginBottom: `${spacing}px`,
        },
      },
      content: {
        "&.Mui-expanded": {
          margin: "12px 0",
        },
      },
    },
    MuiAccordionDetails: {
      root: {
        padding: "0 24px 12px",
      },
    },
    MuiTab: {
      root: {
        flex: 1,
        margin: "4px",
        minHeight: "40px",
        minWidth: "0!important",

        "&.Mui-selected": {
          background: "#ffffff",
          boxShadow: "0px 2px 4px rgba(30, 29, 60, 0.2)",
          borderRadius: "6px",
        },
      },
      wrapper: {
        fontSize: "0.75rem",
        fontWeight: "800",
      },
    },
    MuiButton: {
      root: {
        paddingTop: "8px",
        paddingBottom: "8px",
        borderRadius: "100px",
        fontWeight: "800",
        "&.MuiButton-contained": {
          boxShadow: "none",
        },
      },
      outlined: {
        paddingTop: "8px",
        paddingBottom: "8px",
      },
      sizeSmall: {
        padding: "2px 10px 2px 4px",
      },
    },
    MuiFormControlLabel: {
      label: {
        color: "#f3f3f3",
      },
    },
    MuiInputBase: {
      input: {
        "&:focus": {
          borderRadius: "25px",
        },
      },
    },
    MuiInput: {
      underline: {
        "&:before": {
          display: "none",
        },
        "&:after": {
          display: "none",
        },
      },
    },
    MuiPopover: {
      "&.mobile": {
        paper: {
          width: "100%",
          maxWidth: "100%",
        },
      },
    },
    MuiChip: {
      root: {
        padding: "7px 12px",
        borderRadius: "16px",
        textTransform: "uppercase",
      },
      label: {
        fontWeight: "700",
      },
      avatar: {
        marginLeft: "-5px!important",
      },
      colorPrimary: {
        background: "rgba(2, 62, 217, 0.2)!important",
        color: "#023ED9",
        textTransform: "uppercase",
      },
      colorSecondary: {
        backgroundColor: "#023ED9",
        color: "#ffffff",
        textTransform: "uppercase",
        fontWeight: "600",
      },
    },
    MuiSelect: {
      root: {
        color: "#f3f3f3",
        paddingLeft: spacing,
      },
      select: {
        minWidth: "240px",
        paddingTop: spacing / 2,
        paddingBottom: spacing / 2,
        border: "2px solid #f3f3f3",
        borderRadius: "25px",
        "&:focus": {
          borderRadius: "25px",
        },
      },
      icon: {
        right: spacing / 2,
        color: "#f3f3f3",
      },
    },
    MuiDialogTitle: {
      root: {
        borderBottom: "1px solid #F3F3F3",
        marginBottom: `${spacing}px`,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
      },
    },
    MuiMenu: {
      paper: {
        marginTop: "48px",
        width: "204px",
        borderRadius: "18px",
      },
    },
    MuiDialog: {
      paper: {
        borderRadius: "12px",
      },
      paperWidthSm: {
        maxWidth: "640px",
      },
    },
    MuiDialogActions: {
      root: {
        paddingRight: `${spacing}px`,
        paddingBottom: `${spacing}px`,
        paddingLeft: `${spacing}px`,
      },
    },
    MuiFab: {
      root: {
        boxShadow: "none",
      },
    },
    MuiSnackbar: {
      root: {
        zIndex: 4,
      },
    },
    MuiDropzoneArea: {
      root: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "150px",
        border: "2px dashed #B2B2B2",
        padding: "0 32px",
      },
      icon: {
        display: "none",
      },
      text: {
        fontSize: "0.95rem",
        fontWeight: "600",
      },
    },
  },
  typography: {
    fontFamily: '"Open Sans", sans-serif',
    body1: {
      lineHeight: 1.5,
      fontSize: "1.05rem",
    },
    h1: {
      fontSize: "1.5rem",
      fontWeight: "500",
    },
    h2: {
      fontSize: "2.5rem",
      fontWeight: "600",
    },
    h3: {
      fontSize: "1.30rem",
      fontWeight: "600",
    },
    h4: {
      fontSize: "1.5rem",
      fontWeight: "600",
    },
    h6: {
      fontSize: "1rem",
      fontWeight: "600",
    },
    subtitle2: {
      fontSize: "1rem",
      fontWeight: 600,
    },
    caption: {
      fontSize: "0.9rem",
      color: "#7F7F7F",
    },
  },
  palette: {
    primary: {
      main: "#023ED9",
      backgroundColor: "#1A3241",
    },
    secondary: {
      main: "#101C3D",
      backgroundColor: "#336583",
    },
    text: {
      primary: "#212121",
      secondary: "#f3f3f3",
      disabled: "#aaaaaa",
      light: "#f3f3f3",
    },
    success: {
      main: "#4caf50",
    },
    error: {
      main: "#f44336",
    },
  },
  transitions: {
    duration: 250,
  },
  spacing,
  appBarHeight: 120,
});

export default theme;
